<template>
  <div>
    <v-card class="mb-2">
      <v-card-title class="body-1 pb-0"> Filtros</v-card-title>
      <v-card-text>
        <v-row dense>
          <v-col cols="12" md="2" class="d-flex align-center">
            <v-text-field
              v-model="query"
              placeholder="Buscar"
              tabindex="1"
              outlined
              dense
              hide-details
              class="text-capitalize"
              @change="getNews"
              clearable
            />
          </v-col>
          <v-col cols="12" md="2" class="d-flex align-center">
              <v-select
                v-model="country"
                :items="countries"
                :item-text="(item) => item.name"
                :item-value="(item) => item.id"
                placeholder="País"
                dense
                outlined
                hide-details
                return-object
                @change="changeCountry"
              >
                <template v-slot:item="{ item }">
                  <v-list-item-avatar>
                    {{ item.emoji }}
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title>{{ item.name }}</v-list-item-title>
                  </v-list-item-content>
                </template>
              </v-select>
          </v-col>
          <v-col cols="12" md="2" class="d-flex align-center">
            <v-autocomplete
              v-model="stateFilter"
              :items="stateItems"
              :loading="isStatesLoading"
              placeholder="Departamento"
              tabindex="1"
              clearable
              outlined
              dense
              hide-details
              class="text-capitalize"
              @change="getNews"
            />
          </v-col>
          <v-col cols="12" md="2" class="d-flex align-center">
            <v-autocomplete
              v-model="cityFilter"
              :items="cityItems"
              :loading="isCitiesLoading"
              placeholder="Municipio"
              tabindex="2"
              clearable
              outlined
              dense
              hide-details
              class="text-capitalize"
              @change="getNews"
            />
          </v-col>
          <v-col cols="12" md="2" class="d-flex align-center">
            <v-select
              v-model="categoryFilter"
              :items="categories"
              placeholder="Categoría"
              tabindex="2"
              clearable
              outlined
              dense
              hide-details
              class="text-capitalize"
              @change="getNews"
            />
          </v-col>
          <v-col cols="12" md="2" class="d-flex align-center">
            <v-container>
              <v-overflow-btn
                v-model="timeIntervalFilter"
                :items="timeIntervalFilterOptions"
                label="Fecha"
                item-value="value"
                item-text="text"
                class="mt-0"
                dense
                outlined
                hide-details
                @change="doDateSearch"
              ></v-overflow-btn>
            </v-container>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-card class="mb-2">
      <v-card-text>
        <v-tabs v-model="tabs" grow>
          <v-tab href="#results" class="primary--text d-flex align-center">
            <div>
              <v-icon class="mr-2">list</v-icon>
              <span class="subtitle text-capitalize">Noticias</span>
            </div>
          </v-tab>
          <v-tab href="#dashboard" class="primary--text d-flex align-center">
            <div>
              <v-icon class="mr-2">show_chart</v-icon>
              <span class="subtitle text-capitalize">Dashboard</span>
            </div>
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tabs">
          <v-tab-item key="results" value="results">
            <v-card flat>
              <div class="d-flex justify-end my-2">
                  Mostrando {{ news.length }} de {{ totalNews }} resultados
                </div>
              <div class="d-flex justify-end my-2" v-if="isEditor">
                <v-dialog v-model="showBulkDialog" width="500">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      color="primary"
                      class="mx-2 text-capitalize"
                      v-bind="attrs"
                      v-on="on"
                      outlined
                      small
                    >
                      <v-icon size="18" class="mr-1"
                        >label_important_outline</v-icon
                      >
                      Actualizar Categorias
                    </v-btn>
                  </template>
                  <v-card>
                    <v-card-title class="title lighten-3">
                      Actualizar Categorias
                    </v-card-title>

                    <v-card-text>
                      <v-row>
                        <v-col cols="12">
                          <v-select
                            v-model="categoryBulk"
                            :items="categories"
                            label="Categoría"
                            tabindex="20"
                            outlined
                            required
                          />
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12">
                          <v-select
                            v-model="subcategoryBulk"
                            :items="subcategoriesBulk"
                            label="Subcategoría"
                            tabindex="21"
                            outlined
                            required
                          />
                        </v-col>
                      </v-row>
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        color="grey darken-1"
                        class="text-capitalize"
                        @click="showBulkDialog = false"
                        text
                      >
                        Cancelar
                      </v-btn>

                      <v-btn
                        color="primary"
                        class="text-capitalize"
                        @click="updateArticleBulk()"
                      >
                        Actualizar
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>

                <v-btn
                  color="primary"
                  class="text-capitalize"
                  @click="showAddDialog = true"
                  outlined
                  small
                >
                  <v-icon size="18" class="mr-1">add</v-icon>
                  Adicionar Noticia
                </v-btn>
              </div>
              <div v-if="news.length > 0">
                <v-card
                  v-for="(item, i) in news"
                  :key="i"
                  class="pa-3 mb-2"
                  outlined
                >
                  <v-row>
                    <v-col
                      cols="10"
                      class="d-flex flex-column justify-space-between"
                    >
                      <div>
                        <div class="title">
                          <v-row>
                            <v-col
                              cols="12"
                              class="d-flex justify-space-between"
                            >
                              <div>
                                <span
                                  style="cursor: pointer"
                                  @click="visitArticle(item._source.url)"
                                  >{{ item._source.title }}</span
                                >
                                <v-icon
                                  size="16"
                                  style="cursor: pointer"
                                  @click="editArticle(item, i)"
                                  right
                                  v-if="isEditor"
                                >
                                  mdi-application-edit-outline
                                </v-icon>
                              </div>
                            </v-col>
                          </v-row>
                        </div>
                        <div class="subitle-2 text--secondary">
                          <span v-if="item._source.city">
                            {{ item._source.city }} -
                          </span>
                          <span v-if="item._source.state">
                            {{ item._source.state }} -
                          </span>
                          <span v-if="item._source.source">
                            {{ item._source.source }} -
                          </span>
                          <span>{{
                            item._source.publish_time | moment("from")
                          }}</span>
                        </div>
                      </div>
                      <div class="mt-2">
                        <div
                          class="d-inline"
                          v-if="
                            item._source.metadata &&
                            item._source.metadata.categories_as_labels
                          "
                        >
                          <v-chip
                            v-for="(label, i) in item._source.metadata
                              .categories_as_labels"
                            :key="`cat-${i}`"
                            color="secondary"
                            class="text-capitalize mr-1"
                            outlined
                            small
                          >
                            {{ label.replaceAll("_", " ") }}
                          </v-chip>
                        </div>
                        <div
                          class="d-inline"
                          v-if="
                            item._source.metadata &&
                            item._source.metadata.subcategories_as_labels
                          "
                        >
                          <v-chip
                            v-for="(label, i) in item._source.metadata
                              .subcategories_as_labels"
                            :key="i"
                            color="grey"
                            class="text-capitalize mx-1"
                            outlined
                            small
                          >
                            {{ label.replaceAll("_", " ") }}
                          </v-chip>
                        </div>
                      </div>
                    </v-col>
                    <v-col cols="2">
                      <v-img
                        lazy-src="https://picsum.photos/id/11/10/6"
                        max-height="150"
                        max-width="250"
                        :src="item._source.media"
                        style="border-radius: 4px; cursor: pointer"
                        @click="visitArticle(item._source.url)"
                      ></v-img>
                    </v-col>
                  </v-row>
                </v-card>
              </div>
              <div v-else>
                <v-card>
                  <v-card-text class="text-center">
                    <span class="d-flex align-center">
                      <v-icon size="14" left>info</v-icon>
                      No hay noticias que cumplan tu criterio.
                    </span>
                  </v-card-text>
                </v-card>
              </div>
            </v-card>
          </v-tab-item>
          <v-tab-item key="dashboard" value="dashboard">
            <v-card flat>
              <v-card-text>
                <v-row v-if="dashboardData">
                  <v-col md="6" cols="12">
                    <component
                      v-bind:is="dashboardData.chart1.type"
                      :title="dashboardData.chart1.title"
                      :options="dashboardData.chart1.options"
                      @filter="filter"
                      :height="340"
                    ></component>
                  </v-col>
                  <v-col md="6" cols="12">
                    <component
                      v-bind:is="dashboardData.chart2.type"
                      :title="dashboardData.chart2.title"
                      :options="dashboardData.chart2.options"
                      @filter="filter"
                      :height="340"
                    ></component>
                  </v-col>
                  <v-col md="6" cols="12">
                    <component
                      v-bind:is="dashboardData.chart3.type"
                      :title="dashboardData.chart3.title"
                      :options="dashboardData.chart3.options"
                      @filter="filter"
                      :height="340"
                    ></component>
                  </v-col>
                  <v-col md="6" cols="12">
                    <component
                      v-bind:is="dashboardData.chart4.type"
                      :title="dashboardData.chart4.title"
                      :options="dashboardData.chart4.options"
                      @filter="filter"
                      :height="340"
                    ></component>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
    </v-card>

    <v-dialog v-model="showAddDialog" width="800px">
      <v-card>
        <v-card-title>Adicionar Artículo</v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="newArticle.url"
                label="URL"
                tabindex="31"
                dense
                outlined
                required
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="newArticle.title"
                label="Titulo"
                tabindex="32"
                dense
                outlined
                required
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="newArticle.media"
                label="Thumbnail URL"
                tabindex="33"
                dense
                outlined
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-menu
                v-model="newArticleDateMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                min-width="auto"
                offset-y
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="newArticle.publishTime"
                    label="Fecha de Publicación"
                    append-icon="mdi-calendar"
                    v-bind="attrs"
                    v-on="on"
                    tabindex="34"
                    dense
                    readonly
                    outlined
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="newArticle.publishTime"
                  @input="newArticleDateMenu = false"
                  show-adjacent-months
                ></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-select
                v-model="newArticle.category"
                :items="categories"
                label="Categoría"
                tabindex="35"
                outlined
                dense
                required
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-select
                v-model="newArticle.subcategory"
                :items="subcategoriesNew"
                label="Subcategoría"
                tabindex="36"
                outlined
                dense
                required
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <v-select
                v-model="newArticle.state"
                :items="stateItems"
                label="Departamento"
                tabindex="4"
                outlined
                required
              />
            </v-col>
            <v-col cols="6">
              <v-select
                v-model="newArticle.city"
                :items="cityEditItems"
                label="Municipio"
                tabindex="5"
                outlined
                required
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="d-flex justify-end">
              <v-btn
                color="primary"
                class="text-capitalize"
                @click="addArticle"
                :disabled="!newArticle.url"
                >Guardar</v-btn
              >
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showEditDialog" width="800px">
      <v-card>
        <v-card-title class="title">Editar Artículo</v-card-title>
        <v-card-text>
          <div v-if="editLoading">
            <v-progress-circular indeterminate/>
          </div>
          <div v-else>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="editTitle"
                  label="Titulo"
                  tabindex="3"
                  outlined
                  required
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="6">
                <v-select
                  v-model="editStateId"
                  :items="stateItems"
                  label="Departamento"
                  tabindex="4"
                  outlined
                  required
                />
              </v-col>
              <v-col cols="6">
                <v-select
                  v-model="editCityId"
                  :items="editCityItems"
                  :loading="isEditCityLoading"
                  label="Municipio"
                  tabindex="5"
                  outlined
                  required
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-select
                  v-model="
                    editCategory
                  "
                  :items="categories"
                  label="Categoría"
                  tabindex="6"
                  outlined
                  required
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="d-flex justify-end">
                <v-btn
                  color="primary"
                  class="text-capitalize"
                  @click="updateArticle"
                >
                  <v-icon size="18" class="mr-1">system_update_alt</v-icon>
                  Actualizar
                </v-btn>
              </v-col>
            </v-row>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import _startcase from "lodash.startcase";
import Results from "@/components/dashboard/charts/ResultsChart.vue";
import BarChart from "@/components/dashboard/charts/BarChart.vue";
import PieChart from "@/components/dashboard/charts/PieChart.vue";
import RadialChart from "@/components/dashboard/charts/RadialChart.vue";
import StackedBarChart from "@/components/dashboard/charts/StackedBarChart.vue";
import LineChart from "@/components/dashboard/charts/LineChart.vue";
import AreaChart from "@/components/dashboard/charts/AreaChart.vue";

import CategoryTopic from "@/components/dashboard/viz/CategoryTopic.vue";
import WordCloud from "@/components/dashboard/viz/WordCloud.vue";
import VisNetwork from "@/components/dashboard/viz/VisNetwork.vue";
import MapsMarker from "@/components/dashboard/viz/MapsMarker.vue";
import MapsHeat from "@/components/dashboard/viz/MapsHeat.vue";
import VectorMap from "@/components/dashboard/viz/VectorMap.vue";
import {
  DEFAULT_CHART_DATA_SOURCES,
  getChartOptions,
} from "@/commons/chart-commons.js";

const CATEGORIES_HIERARCHY = {
  ambiental: [
    "protección animal",
    "bosques",
    "ambiental",
    "recursos hídricos",
    "cambio climático",
  ],
  "arte y cultura": ["escultura", "arte y cultura", "música", "cine", "teatro"],
  "ciencia y tecnología": [
    "innovación",
    "investigación",
    "ciencia y tecnología",
  ],
  deporte: ["fútbol", "deporte", "aeróbicos", "ciclismo"],
  "derechos humanos": [
    "desplazamiento forzado",
    "confinamiento",
    "derechos humanos",
    "niñez",
    "maltrato infantil",
    "mujeres",
    "abuso de autoridad",
    "reclutamiento forzado",
    "detención arbitraria",
    "desaparición forzada",
    "desnutrición infantil",
    "violencia lgbti osigd",
  ],
  "diversión y entretenimiento": [
    "espectáculos",
    "restaurantes",
    "bares",
    "farándula",
    "diversión y entretenimiento",
  ],
  economia: [
    "transporte",
    "hidrocarburos",
    "industria",
    "agricultura",
    "turismo",
    "comercio",
    "presupuesto",
    "finanzas",
    "exterior",
    "tributario",
    "minería",
    "energía",
    "ganadería",
    "educación",
    "pae",
  ],
  "gestión del riesgo de desastre": [
    "incendio estructural",
    "gestión del riesgo de desastre",
    "deslizamientos",
    "inundaciones",
    "vendaval",
    "terremotos",
    "incendios forestales",
    "erosión",
  ],
  infraestructura: ["puertos", "infraestructura", "carreteras"],
  judicial: ["procesos judiciales", "corrupción", "judicial"],
  "medio ambiente": ["recursos hídricos"],
  "medios de comunicación": ["radio"],
  militar: ["militar"],
  "moda y diseño": ["moda y diseño"],
  movilidad: [
    "estado de las vías",
    "accidentes de tránsito",
    "congestión vehicular",
    "movilidad",
    "transporte público",
    "bloqueos viales",
  ],
  política: [
    "gobierno",
    "electoral",
    "política",
    "legislativo",
    "relaciones internacionales",
  ],
  "proceso de paz": ["postconflicto"],
  religión: ["religión"],
  salud: [
    "salud",
    "condición física",
    "covid-19",
    "vectores epidémicos",
    "servicios eps",
    "hospitales",
  ],
  seguridad: [
    "homicidio líderes (as) sociales",
    "terrorismo",
    "amenazas",
    "homicidio",
    "secuestro",
    "feminicidio",
    "captura",
    "seguridad",
    "hurto",
    "narcotráfico",
    "violencia política",
    "extorsión",
    "combates",
    "microtráfico",
    "vandalismo",
    "homicidio líderes (as)",
    "homicidio excombatientes",
    "abigeato",
    "amenazas líderes (as) sociales",
  ],
  social: [
    "étnicos",
    "tierras",
    "social",
    "migraciones",
    "protesta social",
    "vivienda",
    "niñez",
    "servicios públicos",
    "amenazas líderes (as) sociales",
    "violencia intrafamiliar",
    "pobreza",
    "suicidio",
    "agrarios",
  ],
};

const EMPTY_ARTICLE = {
  url: "",
  title: "",
  media: "",
  state: "",
  city: "",
  publishTime: "",
  category: "",
  subcategory: "",
};
const COUNTRIES = [
  {
    id: 11,
    name: "Argentina",
    emoji: "\uD83C\uDDE6\uD83C\uDDF7",
  },
  {
    id: 27,
    name: "Bolivia",
    emoji: "\uD83C\uDDE7\uD83C\uDDF4",
  },
  {
    id: 44,
    name: "Chile",
    emoji: "\uD83C\uDDE8\uD83C\uDDF1",
  },
  {
    id: 48,
    name: "Colombia",
    emoji: "\uD83C\uDDE8\uD83C\uDDF4",
  },
  {
    id: 53,
    name: "Costa Rica",
    emoji: "\uD83C\uDDE8\uD83C\uDDF7",
  },
  {
    id: 56,
    name: "Cuba",
    emoji: "\uD83C\uDDE8\uD83C\uDDFA",
  },
  {
    id: 64,
    name: "Ecuador",
    emoji: "\uD83C\uDDEA\uD83C\uDDE8",
  },
  {
    id: 66,
    name: "El Salvador",
    emoji: "\uD83C\uDDF8\uD83C\uDDFB",
  },
  {
    id: 90,
    name: "Guatemala",
    emoji: "\uD83C\uDDEC\uD83C\uDDF9",
  },
  {
    id: 97,
    name: "Honduras",
    emoji: "\uD83C\uDDED\uD83C\uDDF3",
  },
  {
    id: 142,
    name: "Mexico",
    emoji: "\uD83C\uDDF2\uD83C\uDDFD",
  },
  {
    id: 159,
    name: "Nicaragua",
    emoji: "\uD83C\uDDF3\uD83C\uDDEE",
  },
  {
    id: 170,
    name: "Panama",
    emoji: "\uD83C\uDDF5\uD83C\uDDE6",
  },
  {
    id: 172,
    name: "Paraguay",
    emoji: "\uD83C\uDDF5\uD83C\uDDFE",
  },
  {
    id: 173,
    name: "Peru",
    emoji: "\uD83C\uDDF5\uD83C\uDDEA",
  },
  {
    id: 233,
    name: "United States",
    emoji: "\uD83C\uDDFA\uD83C\uDDF8",
  },
  {
    id: 235,
    name: "Uruguay",
    emoji: "\uD83C\uDDFA\uD83C\uDDFE",
  },
  {
    id: 239,
    name: "Venezuela",
    emoji: "\uD83C\uDDFB\uD83C\uDDEA",
  },
];

export default {
  data() {
    return {
      query: "",
      countries: COUNTRIES,
      country: {
        id: 48,
        name: "Colombia",
        emoji: "\uD83C\uDDE8\uD83C\uDDF4",
      },
      stateEntries: [],
      isStatesLoading: false,
      stateFilter: null,
      cityEntries: [],
      isCitiesLoading: false,
      cityFilter: null,
      categoryFilter: "",
      timeIntervalFilter: "24h",
      timeIntervalFilterOptions: [
        {
          text: "24 Horas",
          value: "24h",
        },
        {
          text: "3 Dias",
          value: "three_days",
        },
        {
          text: "1 Semana",
          value: "week",
        },
        {
          text: "1 Mes",
          value: "month",
        },
      ],
      news: [],
      totalNews: 0,
      loading: false,
      category: "",
      subcategory: "",
      showEditDialog: false,
      
      showAddDialog: false,
      newArticle: {
        ...EMPTY_ARTICLE,
      },
      newArticleDateMenu: false,
      
      editLoading: false,
      selectedArticle: null,
      editTitle: null,
      editCategory: null,
      editStateId: null,
      editCityEntries: [],
      editCityId: null,
      isEditCityLoading: false,
      showBulkDialog: false,
      categoryBulk: "",
      subcategoryBulk: "",
      tabs: "dashboard",
      dashboardDefinition: null,
      dashboardData: null,
    };
  },
  components: {
    Results,
    BarChart,
    PieChart,
    RadialChart,
    StackedBarChart,
    LineChart,
    AreaChart,
    CategoryTopic,
    WordCloud,
    VisNetwork,
    MapsMarker,
    MapsHeat,
    VectorMap,
  },
  mounted() {
    this.$eventBus.$on("doKeywordSearch", this.doKeywordSearch);
    this.loadUrlParams();
    this.loadGeoData();
    this.getNews();
  },
  methods: {
    doKeywordSearch(query) {
      this.query = query;
      this.getNews();
    },
    doDateSearch(dateRange) {
      console.log(dateRange);
      this.getNews();
    },

    changeCountry() {
      this.loadGeoData();
      this.getNews();
    },
    getNews() {
      this.setUrlQuery();
      let {
        country,
        query,
        stateFilter,
        cityFilter,
        categoryFilter,
        timeIntervalFilter,
      } = this;

      let searchParams = {
        countryId: country.id,
        search: query,
        timeInterval: timeIntervalFilter,
      };

      if (cityFilter) {
        searchParams.cityId = cityFilter;
      } else if (stateFilter) {
        searchParams.stateId = stateFilter;
      }

      if (categoryFilter) {
        categoryFilter = categoryFilter.replaceAll(" ", "_");
        if (categoryFilter === "Todas") {
          categoryFilter = "";
        } else {
          searchParams.categories = [categoryFilter];
        }
      }

      console.log("getNews", searchParams);

      categoryFilter = categoryFilter
        ? categoryFilter.replaceAll(" ", "_")
        : "";
      this.$http
        .get("/api/news/searchp", {
          params: searchParams,
        })
        .then(async (response) => {
          if (response) {
            console.log(response.data);
            this.news = response.data.hits.hits;
            this.totalNews = response.data.hits.total.value;

            const chartOptions = getChartOptions({
              dataSources: {
                ...DEFAULT_CHART_DATA_SOURCES,
                categories: (data) => data.aggregations.categories.buckets,
              },
            });
            console.log("chartOptions", chartOptions);
            const responseDataCopy = {
              ...JSON.parse(JSON.stringify(response.data)),
              results: response.data.hits.hits,
            };
            this.dashboardDefinition = {
              name: "Noticias",
              charts: [
                "wordcloud",
                "googleMapMarkers",
                "categories",
                "categoriesActivityNews",
              ],
            };
            let dbData = {};
            this.dashboardDefinition.charts.forEach((chart, index) => {
              try {
                console.log("Processing chart", chart);
                dbData["chart" + (index + 1)] = chartOptions[chart](
                  responseDataCopy //Use a copy of the data here because slice modify in place
                );
              } catch (error) {
                console.error("Chart error", chart, error);
              }
            });
            console.log("dbData", dbData);
            this.dashboardData = dbData;
          }
        });
    },
    visitArticle(url) {
      window.open(url, "_blank");
    },
    addArticle() {
      console.log("addArticle", this.newArticle);
      this.$http.post("/api/news", this.newArticle).then(async (response) => {
        if (response) {
          this.showAddDialog = false;
          this.newArticle = { ...EMPTY_ARTICLE };
        }
      });
    },
    editArticle(selectedArticle) {
      console.log("selectedArticle",selectedArticle);
      if (selectedArticle) {
        this.selectedArticle = selectedArticle;
        this.showEditDialog = true;
        this.editTitle = selectedArticle._source.title;
        this.editStateId = selectedArticle._source.state_id;
        this.editCityId = selectedArticle._source.city_id;
        this.editCategory = selectedArticle._source.metadata.categories_as_labels[0];
      }
    },
    updateArticle() {
      let newArticle = { ...this.selectedArticle };
      newArticle._source.title = this.editTitle;
      newArticle._source.state_id = this.editStateId;
      newArticle._source.city_id = this.editCityId;
      newArticle._source.metadata.categories_as_labels = [this.editCategory];

      console.log("updateArticle", newArticle);
      this.$http
        .post("/api/news/update", newArticle)
        .then(async (response) => {
          if (response) {
            this.showEditDialog = false;
            this.selectedArticle = null;
            this.editTitle = null;
            this.editCategory = null;
            this.editStateId = null;
            this.editCityId = null;
            this.setUrlQuery();
          }
        });
    },
    updateArticleBulk() {
      console.log("updateArticleBulk");
      let {
        query,
        stateFilter,
        cityFilter,
        timeIntervalFilter,
        categoryBulk,
        subcategoryBulk,
      } = this;

      this.$http
        .post("/api/news/update/bulk", {
          query,
          state: stateFilter,
          city: cityFilter,
          timeInterval: timeIntervalFilter,
          category: categoryBulk,
          subcategory: subcategoryBulk,
        })
        .then(async (response) => {
          if (response) {
            this.categoryBulk = "";
            this.subcategoryBulk = "";
            this.showBulkDialog = false;
            setTimeout(() => {
              this.getNews();
            }, 5000);
          }
        });
    },
    filter(filterData) {
      console.log("filter", filterData);
      if (filterData) {
        if (filterData[0].source === "wordcloud") {
          if (filterData[0].text) {
            this.$eventBus.$emit("setSearchInput", {
              query: filterData[0].text,
            });
            this.doKeywordSearch(filterData[0].text);
          }
        } else if (
          filterData[0].source === "chart" &&
          filterData[0].title === "Categorias"
        ) {
          this.categoryFilter = filterData[0].text;
          this.getNews();
        }
      }
    },
    loadUrlParams() {
      this.query = this.$route.query.query;
      if (this.$route.query.countryId) {
        this.country = COUNTRIES.find(
          (country) => country.id == this.$route.query.countryId
        );
      }

      if (this.$route.query.stateId){
        this.stateFilter = this.$route.query.stateId;
      }
      
      if (this.$route.query.category){
        this.categoryFilter = this.$route.query.category;

      }

      if (this.$route.query.timeInterval){
        this.timeIntervalFilter = this.$route.query.timeInterval;
      }

    },
    loadGeoData() {
      if (this.isStatesLoading) return;
      this.isStatesLoading = true;


      console.log("loadStates for countryId", this.country.id);
      this.$http
        .get(`/api/statesByCountry/${this.country.id}`)
        .then((response) => {
          if (response) {
            this.stateEntries = response.data.states;
            this.isStatesLoading = false;
            let stateId = this.$route.query.stateId;
            if (stateId) {
              if (this.stateEntries.length > 0) {
                console.log("stateId from URL", stateId);
                let stateUrl = response.data.states.find(
                  (state) => state.id == stateId
                );
                if (stateUrl) {
                  this.stateFilter = stateUrl.id;
                }
              }
            } else {
              console.log("no stateId from URL");
              this.stateFilter = null;
            }
          }
          this.getNews();
        });
    },
    setUrlQuery() {
      let newQuery = {};
      if (this.country) {
        newQuery.countryId = this.country.id;
      }
      if (this.stateFilter) {
        newQuery.stateId = this.stateFilter;
      }
      if (this.cityFilter) {
        newQuery.cityId = this.cityFilter;
      }
      if (this.categoryFilter) {
        newQuery.category = this.categoryFilter;
      }
      if (this.timeIntervalFilter) {
        newQuery.timeInterval = this.timeIntervalFilter;
      }
      this.$router.replace({
        ...this.$route,
        query: {
          ...newQuery,
        },
      });
    },
  },
  computed: {
    stateItems() {
      return this.stateEntries.map((entry) => {
        return {
          text: entry.name,
          value: entry.id,
        };
      });
    },
    cityItems() {
      return this.cityEntries.map((entry) => {
        return {
          text: entry.name,
          value: entry.id,
        };
      });
    },
    cityEditItems() {
      return this.cityEntries.map((entry) => {
        return {
          text: entry.name,
          value: entry.id,
        };
      });
    },
    editCityItems() {
      return this.editCityEntries.map((entry) => {
        return {
          text: entry.name,
          value: entry.id,
        };
      });
    },
    isEditor() {
      return this.$store.state.userRoles.includes("editor");
    },
    categories() {
      return Object.keys(CATEGORIES_HIERARCHY).map((key) => {
        return {
          text: _startcase(key),
          value: key,
        };
      });
    },
    subcategoriesNew() {
      if (!!this.newArticle && !!this.newArticle.category) {
        const selectedCategory = CATEGORIES_HIERARCHY[this.newArticle.category];
        if (!!selectedCategory) {
          return selectedCategory.map((key) => {
            return {
              text: _startcase(key),
              value: key,
            };
          });
        }
      }
    },
    subcategoriesEdit() {
      if (
        !!this.selectedArticle &&
        !!this.selectedArticle._source &&
        !!this.selectedArticle._source.metadata &&
        !!this.selectedArticle._source.metadata.categories_as_labels
      ) {
        const category =
          this.selectedArticle._source.metadata.categories_as_labels[0];
        const selectedCategory = CATEGORIES_HIERARCHY[category];
        if (!!selectedCategory) {
          return selectedCategory.map((key) => {
            return {
              text: _startcase(key),
              value: key,
            };
          });
        }
      }
    },
    municipiosNew() {
      // if (!!this.newArticle && !!this.newArticle.state) {
      //   return COLOMBIA_STATES[this.newArticle.state];
      // } else {
      //   let municipiosTemp = [];
      //   Object.entries(COLOMBIA_STATES).forEach(([key, value]) => {
      //     municipiosTemp.push(...value);
      //   });
      //   return municipiosTemp;
      // }
    },
    municipiosEdit() {
      // if (
      //   !!this.selectedArticle &&
      //   !!this.selectedArticle._source &&
      //   !!this.selectedArticle._source.state
      // ) {
      //   return COLOMBIA_STATES[this.selectedArticle._source.state];
      // } else {
      //   let municipiosTemp = [];
      //   Object.entries(COLOMBIA_STATES).forEach(([key, value]) => {
      //     municipiosTemp.push(...value);
      //   });
      //   return municipiosTemp;
      // }
    },
    subcategoriesBulk() {
      const selectedCategory = CATEGORIES_HIERARCHY[this.categoryBulk];
      if (!!selectedCategory) {
        return selectedCategory.map((key) => {
          return {
            text: _startcase(key),
            value: key,
          };
        });
      }
    },
  },
  watch: {
    stateFilter() {
      console.log("stateFilter", this.stateFilter);
      if (!this.stateFilter){
        this.cityEntries = [];
        return;
      } 
      if (this.isCityLoading) return;

      this.isCityLoading = true;
      console.log("loadCities for stateId", this.stateFilter);
      this.$http
        .get(`/api/citiesByState/${this.stateFilter}`)
        .then((response) => {
          if (response) {
            this.isCityLoading = false;
            this.cityEntries = response.data;
          }
        });


      
    },
    editStateId() {
      console.log("editStateId", this.editStateId);
      if (!this.editStateId) {
        this.editCityEntries = [];
        return;
      }
      if (this.isEditCityLoading) return;

      this.isEditCityLoading = true;
      console.log("loadCities for stateId", this.editStateId);
      this.$http
        .get(`/api/citiesByState/${this.editStateId}`)
        .then((response) => {
          if (response) {
            this.isEditCityLoading = false;
            this.editCityEntries = response.data;
            this.editLoading = false;
          }
        });
    },
  },
};
</script>

<style>
</style>